import PropTypes from 'prop-types';
import React from 'react';

import i18n from '../../i18n';

import Exchange from '../../models/Exchange';

import FormatCurrency from '../common/CurrencyFormatter';
import Tooltip from '../widget/Tooltip';
import { CurrencyFormatter } from '../../utils/Intl';

export default class GuestpointsPurchaseRow extends React.Component {
    static propTypes = {
        exchange: PropTypes.instanceOf(Exchange).isRequired,
        currency: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.fieldRef = React.createRef();
    }

    render() {
        const { exchange, currency } = this.props;
        const total = exchange.getGpDiscountTotal() + exchange.getGpFullPriceTotal();
        const totalGp = exchange.get('additional_gp_discount') + exchange.get('additional_gp_full_price');
        if (total > 0) {
            return (
                <div className="extra editable-field guestpoints-purchase" ref={this.fieldRef}>
                    <span>
                        {i18n.t('exchange:messaging.purchase.missing_gp', {
                            amount: totalGp
                        })}
                        <Tooltip
                            title={i18n.t('exchange:messaging.purchase.missing_gp.tooltip', {
                                amount: CurrencyFormatter.format(total, currency)
                            })}
                        />
                    </span>
                    <span className="value">
                        <span className="pull-right">
                            <FormatCurrency value={total} />
                        </span>
                    </span>
                </div>
            );
        }
        return false;
    }
}
